export default "assets/frame-6.37d1a0d65dababc9.png"